export enum Modalidad{
    CARRERAS = 'CARRERAS',
    HOCKEY = 'HOCKEY',
    ARTISTICO = 'ARTISTICO',
    SKATEBOARDING = 'SKATEBOARDING',
    INLINE_DOWNHILL = 'INLINE_DOWNHILL',
    INLINE_FREESTYLE = 'INLINE_FREESTYLE'
}
